import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(({palette, variables }) => ({
  courierDetailWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: variables?.spacingD,
    marginBottom: variables?.spacingC,
    '& h3': {
      fontSize: '1.25rem',
      fontWeight: 700,
      lineHeight: '1.5',
      margin: `${variables?.spacingNone} ${variables?.spacingNone} ${variables?.spacingA}`,
    },
    '& .delivery-status': {
      color: palette.secondary.light,
      backgroundColor: palette.secondary.contrastText,
      fontSize: '0.75rem',
      lineHeight: 1.3333333,
      fontWeight: 700,
      display: 'inline-block',
      padding: `${variables?.spacingNone} ${variables?.spacingA}`,
      margin: `${variables?.spacingNone} ${variables?.spacingNone} ${variables?.spacingA}`,
      borderRadius: '2px',
      '&.no-orders': {
        backgroundColor: palette.success.light,
      },
    },
    '& .return-eta': {
      fontSize: '0.875rem',
      fontWeight: 700,
      margin: 0,
    },
    '&.mobile': {
      zIndex: 1,
      position: 'fixed',
      bottom: '72px',
      left: variables?.spacingC,
      right: variables?.spacingC,
      background: 'white',
      minHeight: '100px',
      maxHeight: '180px',
      borderTop: `1px solid ${palette.jet?.borderDefault}`,
      borderRadius:variables?.radiusRoundedC,
      boxShadow:variables?.elevation01,
      '& ul': {
        overflow: 'hidden',
      },
      '&.orderDetail': {
        position:'absolute',
        top:variables?.spacingF
      }
    },
    '&.orderDetail': {
      //minHeight: 'calc(100% - 72px)',
      overflow: 'hidden',
      //position: 'absolute',
      maxHeight: '100%',
      borderTop: '0 !important',
      boxShadow: variables?.elevation01
    },
  },
  courierDetailHighlight: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    height: '100%',
    width: '84px',
  },
  courierDetailBadge: {
    backgroundColor: palette.jet?.containerDark,
    padding: variables?.spacingB,
    color: palette.jet?.containerDefault,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '30px',
    borderRadius: '2px',
    '& p': {
      borderRadius: '22px',
      display: 'inline-block',
      padding: '0px 6px',
      fontsize: '.750rem',
      fontWeight: 700,
      lineHeight: '1rem',
    },
  },
  courierDetailInfo: {
    flex: 1,
  },
  
  courierDetailClose: {
    display: 'flex',
    width: '15px',
    paddingTop: variables?.spacingB,
    '& img': {
      width: 'inherit',
    },
    '&:hover': {
      cursor: 'pointer',
    },
  },
  closeButton: {
    position: 'relative',
    display: 'flex',
    top: `-${variables?.spacingA}`,
  },
  closeButtonIcon: {
    width: `${variables?.spacingD}`,
    height: `${variables?.spacingD}`,
  },
  list: {
    margin: `${variables?.spacingNone}`,
    padding: variables?.spacingD,
    listStyle: 'none',
    '& li': {
      margin: `${variables?.spacingNone} ${variables?.spacingNone} ${variables?.spacingD}`,
      '&:last-child': {
        margin: 0,
      },
    },
  },
  
  mobileShowOrders: {
    width: '100%',
    marginTop: variables?.spacingD,
  },
  showOrdersButton: {
    height: '36px',
    borderRadius: variables?.radiusRoundedE,
    textTransform: 'capitalize',
  },
  courierInfoWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    width: '100%',
    padding: variables?.spacingD,
    paddingRight:0,
    borderBottom: `2px solid ${palette.jet?.borderSubtle}`,
  },
  orderListItemsMobile: {
    width: '100%',
    marginTop: `${variables?.spacingD}`,
    flexDirection: 'column',
    overflow:'auto',
    '& ul': {
      width: '100%',
      padding: `${variables?.spacingNone}`,
    }
  },

  courierDetailTitle: {
    marginBottom: variables?.spacingA
  }


}));

export default styles;
